module.exports = __webpack_public_path__ + "static/img/刘文虎A.b3154e46.png";